import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import SelectBoxItemT from '@/Controls/SelectBoxItem';

export default class SelectBoxBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.selectBoxItems = {
            init: (node: HTMLElement, valueAccessor: () => any) => {
                let SelectBoxItem = ComponentManager.getControl<typeof SelectBoxItemT>('SelectBoxItem');

                let selectBox = $(node);
                let options = valueAccessor();
                let items = options.items();

                options.parent.items = [];

                for (let i = 0; i < items.length; i++) {
                    let selectBoxItem = new SelectBoxItem(items[i], $('<li>').appendTo(selectBox));
                    let tuple = selectBoxItem.getTuple();

                    options.parent.items.push(selectBoxItem);
                }
            }
        };
    }
}